<template>
  <div class="header">
    <div class="header-top">
      <div class="header-top-row container">
        <div class="header-top-content">
          <div class="content-left">
            <div class="logo">
              <img src="@/assets/images/logo.jpg" alt="logo" style="width: 65px; margin-right: 10px">
              <div>
                <b style="color: #1E55AE; font-size: 28px">恩莱吉能源科技</b>
                <br/>
                <span style="color: #CCCCCC; font-size: 13px">Energy Science and Technology</span>
              </div>
            </div>
            <div class="erect-line"></div>
            <div class="header-slogan">
              <div>
                <span style="font-size: 16px;color: #1E55AE; line-height: 25px">
                  <b>专注水电站领域 — 国内领先</b>
                </span>
                <br/>
                <span style="font-size: 14px;color: #A6A6BA;">
                  简约为本，创新为质
                </span>
              </div>
            </div>
          </div>
          <div class="content-right">
            <img src="@/assets/images/phone-logo.png" alt="phone-logo" style="margin-right: 18px">
            <div>
              <span style="font-size: 14px;">服务热线：</span>
              <br/>
              <span style="color: #1E55AE;font-size: 22px;">
                {{ this.firstContact.telephone }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-nav" @mouseleave="subNavShow=false">
      <nav class="header-nav-row container">
        <ul class="first-nav">
          <li v-for="item in navData"
              :key="item.id"
              @mouseenter="getSubNav(item)"
              :class="{active:$route.path === item.toPath}"
          >
            <span @click="anchorJump(item)">{{ item.name }}</span>
          </li>
        </ul>
      </nav>
      <Transition name="sub-nav">
        <ul class="sub-nav" v-show="subNavShow">
          <li v-for="item in this.activeNav.subNavData" :key="item.anchorId">
            <span @click="anchorJump(item)">{{ item.name }}</span>
          </li>
        </ul>
      </Transition>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "Header",
  comments: {},
  data() {
    return {
      subNavShow: false,
      activeNav: {},
      navData: [
        {
          id: 1,
          name: '首页',
          toPath: '/home',
        },
        {
          id: 2,
          name: '关于我们',
          toPath: '/about',
          subNavData: [
            {id: 1, name: '公司简介', anchorId: 'about-introduce'},
            {id: 2, name: '董事长寄语', anchorId: 'about-bossMessage'},
            {id: 3, name: '文化理念', anchorId: 'about-cultural'},
            {id: 4, name: '核心业务', anchorId: 'about-business'},
            {id: 4, name: '联系我们', anchorId: 'about-contact'},
          ]
        },
        {
          id: 3,
          name: '技术与产品',
          toPath: '/product',
        },
        {
          id: 4,
          name: '工程业绩',
          toPath: '/project',
          subNavData: [
            {id: 1, name: '代表工程', anchorId: 'project-deputy'},
            {id: 2, name: '主要工程', anchorId: 'project-main'},
            {id: 3, name: '高油压桨叶调节装置专题', anchorId: 'project-special-subject'},
          ]
        },
        {
          id: 5,
          name: '专利证书',
          toPath: '/certificate',
          subNavData: [
            {id: 1, name: '发明专利', anchorId: 'certificate-invent'},
            {id: 2, name: '计算机软件著作权', anchorId: 'certificate-software'},
            {id: 3, name: '实用新型专利', anchorId: 'certificate-practical'},
            {id: 4, name: '资质证书', anchorId: 'certificate-qualification'},
          ]
        },
        {
          id: 6,
          name: '新闻资讯',
          toPath: '/news',
        },

      ],
    }
  },
  computed: {
    ...mapState('about', ['firstContact'])
  },
  methods: {
    // 实现描点跳转
    goAnchor(id) {
      try {
        const anchor = document.getElementById(id);
        anchor.scrollIntoView({behavior: "smooth"});
      } catch (e) {
        void(0)
        // this.$message({type: 'error', message: '锚点不存在！' + e})
      }
    },

    // 获取二级导航
    getSubNav(activeNav) {
      this.subNavShow = true
      this.activeNav = activeNav
    },

    // 锚跳
    anchorJump(anchorItem) {
      const anchorId = anchorItem.anchorId
      const toPath = this.activeNav.toPath
      if (toPath !== this.$route.path) {
        this.$router.push({path: toPath, name: toPath.replace('/', ''), params: {anchorItem}})
      } else {
        if(anchorId) {
          if (anchorId.indexOf('certificate') !== -1) {
            this.$bus.$emit("goAnchorModel", anchorItem)
          } else {
            this.$nextTick(() => {
              this.goAnchor(anchorId)
            })
          }
        }
      }
    }
  },

  mounted() {
    this.$bus.$on("goAnchor", this.goAnchor)
  },

  beforeDestroy() {
    this.$bus.$off("goAnchor")
  }
}
</script>

<style scoped lang="less">
@main-color: #1E55AE;

.header {
  .header-top {
    display: flex;
    align-items: center;
    height: 100px;
    background-color: white;

    .header-top-row {

      .header-top-content {
        display: flex;
        justify-content: space-between;
        @htc-h: 58px;
        height: @htc-h;

        .content-left {
          display: flex;
          justify-content: left;
          height: 100%;

          .logo, .header-slogan {
            display: flex;
            align-items: center;
            height: @htc-h;
          }

          .erect-line {
            margin: 0 40px;
            height: 100%;
            width: 1px;
            background-color: #E6E6E6;
          }
        }

        .content-right {
          display: flex;
          align-items: center;
          height: @htc-h;
        }
      }
    }
  }

  .header-nav {
    position: relative;
    @hn-h: 50px;
    height: @hn-h;
    background-color: @main-color;

    .header-nav-row {

      .first-nav {
        display: flex;
        justify-content: left;
        font-size: 16px;
        color: white;

        li {

          span {
            display: block;
            padding: 0 35px;
            min-width: 65px;
            line-height: @hn-h;
            text-align: center;
            color: white;

            &:hover {
              background-color: #13439D;
              cursor: pointer;
            }
          }
        }

        .active {
          background-color: #13439D;
        }
      }
    }

    .sub-nav {
      display: flex;
      justify-content: center;
      position: absolute;
      width: 100%;
      background-color: white;
      z-index: 9;

      li {
        padding: 5px 15px;
        margin: 10.92px 0;
        min-width: 65px;
        border-right: 1px solid #E6E6E6;
        text-align: center;

        &:last-child {
          border: none;
        }

        span {
          font-size: 14px;
          color: #333;

          &:hover {
            color: #1E55AE;
            cursor: pointer;
          }
        }
      }
    }

    .sub-nav-enter-active,
    .sub-nav-leave-active {
      transition: all 0.3s ease;
    }

    .sub-nav-enter,
    .sub-nav-leave-to {
      opacity: 0;
    }
  }
}
</style>